export default {"src":"/_next/static/media/quote.fff6334c.svg","height":59,"width":67};